import { IconButton, Stack } from '@mui/material';
import { TrashIcon } from '@phosphor-icons/react';

import { Text, colors, isDefined } from 'common';

import { useReactFlowViewContext } from '../../../../context/context';

interface HumanTaskWorkContextHeaderProps {
  headerLabel: string;
  onDelete?: () => void;
}

export function HumanTaskWorkContextHeader(props: HumanTaskWorkContextHeaderProps) {
  const { headerLabel, onDelete } = props;
  const { isEditable } = useReactFlowViewContext();
  return (
    <Stack
      direction="row"
      paddingX={2}
      paddingY={1}
      justifyContent="space-between"
      alignItems="center"
      sx={{
        backgroundColor: colors.background.disabled,
        borderRadius: 1,
      }}
    >
      <Text variant="heading5" bold>
        {headerLabel}
      </Text>
      <IconButton
        aria-label="Delete Field"
        size="medium"
        onClick={onDelete && (() => onDelete())}
        disabled={!isEditable || !isDefined(onDelete)}
      >
        <TrashIcon size={16} />
      </IconButton>
    </Stack>
  );
}
